module.exports = __webpack_public_path__ + "img/p.8bb0bfbc.jpg";